import { Link } from "react-router-dom";
import './landingPrimaryLink.css';

export default function LandingPrimaryButton(props) {
  return <Link to={props.path} className="landing-primary-button" onClick={props.onClick}>
    {props.text}
    {props.children}
  </Link>
}